export enum TenantApplicationRoleNames {
  TENANT = 'TENANT',
  INVITED_GUARANTOR = 'INVITED_GUARANTOR',
}
